import {
  FETCH_USERS_REQUEST,
  FETCH_USERS_SUCCESS,
  FETCH_USERS_FAILURE,
  FETCH_USER_REQUEST,
  FETCH_USER_SUCCESS,
  FETCH_USER_FAILURE,
  USER_REGISTER_REQUEST,
  USER_REGISTER_SUCCESS,
  USER_REGISTER_FAIL,
} from '../actions/types';

const initialState = {
  users: [],           // accumulated users list
  userProfile: null,
  loading: false,
  error: null,
  registrationError: null,
  newUser: null,
  page: 1,             // current page
  hasMore: true,       // is there more data to load?
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch Users Actions
    case FETCH_USERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_USERS_SUCCESS: {
      const { data } = action.payload;
      return {
        ...state,
        loading: false,
        users: data || [],
        page: 1,
        hasMore: false,
      };
    }


    case FETCH_USERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Fetch Logged-In User Profile
    case FETCH_USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        userProfile: action.payload,
      };
    case FETCH_USER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Register User Actions
    case USER_REGISTER_REQUEST:
      return {
        ...state,
        loading: true,
        registrationError: null, // Clear previous registration errors
      };
    case USER_REGISTER_SUCCESS:
      return {
        ...state,
        loading: false,
        newUser: action.payload, // Store new user data
      };
    case USER_REGISTER_FAIL:
      return {
        ...state,
        loading: false,
        registrationError: action.payload, // Store registration error
      };

    default:
      return state;
  }
};

export default userReducer;
